/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('tooltipster/dist/js/tooltipster.bundle.min.js');
require('./jquery_plugins/button-loading');
require('bootstrap-select/dist/js/bootstrap-select.min');

import axios from 'axios';

window.Vue = require('vue');
window.axios = axios;
window.axios.defaults.baseURL = window.app_url;

// Injecting lodash into Vue prototype to be able to use '_' in templates
Object.defineProperty(Vue.prototype, '_', { value: window._ });

import jqueryForm     from 'jquery-form';
import VueSimpleSVG   from 'vue-simple-svg';
import Root           from './components/Root.vue';
import VueRouter      from 'vue-router';
import Vuex           from 'vuex';
import routes         from './routes';
import Store          from './store';
import vSelect        from 'vue-select';
import Notifications  from 'vue-notification';
import InputTag       from 'vue-input-tag';
import PrettyCheckbox from 'pretty-checkbox-vue';
import VueDraggable   from 'vuedraggable';
import DatePicker     from 'vue2-datepicker';

//import MobileSelect from 'mobile-select';

import {ClientTable, ServerTable, Event} from 'vue-tables-2';

import html2Canvas from 'html2canvas';
import jspdf       from 'jspdf';
import pptxgenjs   from 'pptxgenjs';
window.html2canvas = html2Canvas;
window.jsPDF       = jspdf;
window.PptxGenJS   = pptxgenjs;

//Highcharts
import Highcharts from 'highcharts';
import mapInit from 'highcharts/modules/map';
import addWorldMap from './highcharts/world';
import addEuropeMap from './highcharts/europe';
import addNorthAmericaMap from './highcharts/north-america';
import addSouthAmericaMap from './highcharts/south-america';
import addAsiaMap from './highcharts/asia';
import addAfricaMap from './highcharts/africa';
import addOceaniaMap from './highcharts/oceania';
mapInit(Highcharts);
addWorldMap(Highcharts);
addEuropeMap(Highcharts);
addNorthAmericaMap(Highcharts);
addSouthAmericaMap(Highcharts);
addAsiaMap(Highcharts);
addAfricaMap(Highcharts);
addOceaniaMap(Highcharts);
window.Highcharts = Highcharts;

// Mixins
import HelperFunctions from './mixins/HelperFunctions';
import Messages        from './mixins/Messages';

//elements
import KpiTop from './components/reporting/elements/kpi/KpiTop.vue';
import KpiSocial from './components/reporting/elements/kpi/KpiSocial.vue';
import SocialCampaignDetails from './components/reporting/elements/kpi/SocialCampaignDetails.vue';
import SingleTable from './components/reporting/elements/tables/SingleTable.vue';
import SingleTableBlue from './components/reporting/elements/tables/SingleTableBlue.vue';
import DoubleTable from './components/reporting/elements/tables/doubleTables/DoubleTable.vue';
import TripleTable from './components/reporting/elements/tables/tripleTables/TripleTable.vue';
import AdvertisingVisuals from './components/reporting/elements/visuals/AdvertisingVisuals.vue';
import AdwordsVisuals from './components/reporting/elements/visuals/AdwordsVisuals.vue';
import TopSocialAdCreatives from './components/reporting/elements/creatives/TopSocialAdCreatives.vue';
import Chart from './components/reporting/elements/charts/Chart.vue';
import DetailsCard from './components/reporting/elements/cards/DetailsCard.vue';
import ReportHighlights from './components/reporting/elements/cards/ReportHighlights.vue';
import UpdatesAndInsights from './components/reporting/elements/cards/UpdatesAndInsights.vue';
import SocialKeyTakeaways from './components/reporting/elements/cards/SocialKeyTakeaways.vue';
import KeyTakeaways from './components/reporting/elements/cards/KeyTakeaways.vue';
import SocialOrganicPerformanceHighlights from './components/reporting/elements/visuals/SocialOrganicPerformanceHighlights.vue';
import SocialOrganicInstagramGrid from './components/reporting/elements/visuals/SocialOrganicInstagramGrid.vue';
import TextBox from './components/reporting/elements/cards/TextBox.vue';
import Heading from './components/reporting/elements/Heading.vue';
import MetricGlossary from './components/reporting/elements/tables/MetricGlossary.vue';
import PageBreak from './components/reporting/elements/PageBreak.vue';

//commons
import DateButtons from './components/reporting/common/DateButtons.vue';

import Dayjs from 'vue-dayjs';

window.BootstrapDialog = require('./jquery_plugins/bootstrap-dialog');

Vue.use(Dayjs, {lang: 'en', filters:{ago:'ago'}, directives:{countdown:'countdown'}});
Vue.use(VueSimpleSVG);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(ClientTable, {sortIcon: { base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort' }, perPage: 999, perPageValues:[999]}, false, 'bootstrap4');
Vue.use(ServerTable);
Vue.use(Event);
Vue.use(Notifications);
Vue.use(PrettyCheckbox);
Vue.use(DatePicker);
Vue.mixin(HelperFunctions);
Vue.mixin(Messages);

Vue.component('draggable', VueDraggable);
Vue.component('v-select', vSelect);
Vue.component('input-tag', InputTag);
Vue.component('kpiTop', KpiTop);
Vue.component('kpiSocial', KpiSocial);
Vue.component('socialCampaignDetails', SocialCampaignDetails);
Vue.component('singleTable', SingleTable);
Vue.component('singleTableBlue', SingleTableBlue);
Vue.component('doubleTable', DoubleTable);
Vue.component('tripleTable', TripleTable);
Vue.component('advertisingVisuals', AdvertisingVisuals);
Vue.component('adwordsVisuals', AdwordsVisuals);
Vue.component('topSocialAdCreatives', TopSocialAdCreatives);
Vue.component('chart', Chart);
Vue.component('detailsCard', DetailsCard);
Vue.component('reportHighlights', ReportHighlights);
Vue.component('updatesAndInsights', UpdatesAndInsights);
Vue.component('socialKeyTakeaways', SocialKeyTakeaways);
Vue.component('keyTakeaways', KeyTakeaways);
Vue.component('socialOrganicPerformanceHighlights', SocialOrganicPerformanceHighlights);
Vue.component('socialOrganicInstagramGrid', SocialOrganicInstagramGrid);
Vue.component('textBox', TextBox);
Vue.component('heading', Heading);
Vue.component('metric-glossary', MetricGlossary);
Vue.component('page-break', PageBreak);
Vue.component('dateButtons', DateButtons);

//Vue.use(MobileSelect);

$.fn.selectpicker.Constructor.BootstrapVersion = '4';

const router = new VueRouter(routes);
const store  = new Vuex.Store(Store);

store.commit('setAuthUser', window.auth_user);
store.commit('setAppUrl', window.app_url);
store.commit('setUrlParams', window.url_params);

router.beforeEach((to, from, next) => {
    if (window.vm) {
        vm.loading = true;
    }

    const permission = to.meta.permission;
    const original_permission = !!store.getters.getAuthUser ? store.getters.getAuthUser.original.permissions : '';

    document.title = 'KBP' + (to.meta.title ? ' - ' + to.meta.title : '');

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!window.auth_user) {
            window.location.href = window.app_url + 'login';
        }
        else if (typeof permission !== 'undefined' && !original_permission[permission]) {
            return next({path: '/errors/403'});
        }
        else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
});

// Axios
let pendingRequestsCount = null;
let CancelToken          = axios.CancelToken;
let source               = CancelToken.source();

axios.interceptors.request.use((config) => {
    if (pendingRequestsCount === null) {
        vm.loading = true;
        pendingRequestsCount = 0;
    }

    ++pendingRequestsCount;

    config.cancelToken = source.token;
    return config;
});

axios.interceptors.response.use(success => {
    --pendingRequestsCount;

    if (!pendingRequestsCount) {
        if (!success.config.url.includes('browsershot')) {
            vm.loading = false;
        }
    }

    return success;
}, error => {
    vm.loading = false;

    if (/code 419/.test(error) || /code 401/.test(error)) {//session expired
        window.location.href = vm.$store.state.app_url + 'session_expired';

        return Promise.reject(error);
    }

    if (error.response.status == 404 || error.response.status == 403) {
        pendingRequestsCount = null;

        if (window.location.pathname !== `/errors/${error.response.status}`) {
            return window.vm.$router.push({path: `/errors/${error.response.status}`});
        } else {
            return Promise.reject(error);
        }
    } else {
        window.vm.$notify({
            type: 'error',
            text: error.response.data.message || 'Some unknown error occurred',
            duration:5000
        });
    }

    if(_.has(error.response.data, 'missed_metrics')){
        window.event_bus.$emit('missed_metrics', error.response.data.missing_metrics_infos);
    }
    return Promise.reject(error);
});

window.event_bus = new Vue({});
window.vm = new Vue({
    el: '#app',
    components: { Root: Root },
    router: router,
    store: store,

    data() {
        return {
            loading: false
        }
    }
});

window.vm.init();

//froala editorr
require('froala-editor/js/froala_editor.pkgd.min.js');
require('froala-editor/js/plugins/font_family.min.js');
